import { render, staticRenderFns } from "./VectorObjectLocator.vue?vue&type=template&id=5ba76e98&scoped=true&"
import script from "./VectorObjectLocator.vue?vue&type=script&lang=ts&"
export * from "./VectorObjectLocator.vue?vue&type=script&lang=ts&"
import style0 from "./VectorObjectLocator.vue?vue&type=style&index=0&id=5ba76e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba76e98",
  null
  
)

export default component.exports